import { Button, SvgExternalLink } from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import * as analytics from 'utilities/analytics';

import ShareVideoImg from 'img/workspace-onboarding/share-your-video.png';

import useClipboard from '../../../../../../hooks/useClipboard';
import DashboardOnboardingCard, {
  DashboardOnboardingSecondaryAction,
} from '../..';
import { completeElementHandler } from '../../../utilities';
import { launchShareVideoArticleLink } from '../../../../onboarding-actions';
import { DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED } from '../../../../../../constants/events';
import { LOOM_URI } from '../../../../../../constants/routes';
import { useGetSelectedWorkspace } from '../../../../../../hooks/workspace';
import { SHARE_VIDEO_CARD_KEY } from '../../../../../../../../shared/constants/workspaceOnboarding';

const MOST_RECENT_VIDEO = `${LOOM_URI}/most-recent-video`;

const ShareVideoCard = ({ cardConfig }) => {
  const dispatch = useDispatch();
  const [, setCopied] = useClipboard(MOST_RECENT_VIDEO);
  const header = 'Share your video';
  const description = 'Send your recording via a link or in an app.';
  const completeMessage = 'Link copied! Now go share your video.';

  const selectedWorkspace = useGetSelectedWorkspace();

  if (!selectedWorkspace) {
    return null;
  }

  const primaryAction = (
    <Button
      onClick={() => {
        setCopied();

        completeElementHandler(
          dispatch,
          SHARE_VIDEO_CARD_KEY,
          selectedWorkspace.id
        );

        analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
          type: 'primary',
          card: SHARE_VIDEO_CARD_KEY,
        });
      }}
    >
      Copy video link
    </Button>
  );
  const secondaryAction = (
    <DashboardOnboardingSecondaryAction
      icon={<SvgExternalLink />}
      onClick={launchShareVideoArticleLink}
    >
      Learn how
    </DashboardOnboardingSecondaryAction>
  );
  const centerpiece = <img src={ShareVideoImg} />;

  return (
    <DashboardOnboardingCard
      cardKey={SHARE_VIDEO_CARD_KEY}
      cardConfig={cardConfig}
      heading={header}
      description={description}
      centerpiece={centerpiece}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      completeMessage={completeMessage}
    />
  );
};

export default ShareVideoCard;
